import 'src/assets/js/desktop/shared/favorite_products_counter';
